// intersected with Record<string, string> (rather than a plain interface) so
// this is directly assignable to string-keyed observability sinks like Faro's
// ExceptionContext, with no cast needed at the app-side bridge.
export type UiErrorReportContext = Record<string, string> & {
  area: string;
  errorBoundary: string;
  pathname: string;
  source: string;
  componentStack?: string;
};

let reportImpl: (
  error: Error,
  context: UiErrorReportContext,
) => void = () => {};

// the design system surfaces error-boundary catches through the consuming
// app's observability stack. call this once at the app entrypoint to wire it up.
export function initUiErrorReporting(
  report: (error: Error, context: UiErrorReportContext) => void,
): void {
  reportImpl = report;
}

export function reportUiError(
  error: Error,
  context: UiErrorReportContext,
): void {
  reportImpl(error, context);
}
